<template>
  <center>
    <div class="round">
      <a
        :href="`#${link_to}`"
        style="text-decoration: none"
        aria-label="scroll down"
      >
        <div id="cta">
          <v-icon class="arrow primera">mdi-chevron-right</v-icon>
          <v-icon class="arrow segunda">mdi-chevron-right</v-icon>
        </div>
      </a>
    </div>
  </center>
</template>

<script>
export default {
  props: {
    link_to: String,
  },
};
</script>

<style>
body {
  background: #000;
  color: #fff;
}

.round {
  border: 2px solid #fff;
  color: #fff;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  padding: 0px;
  transform: rotate(90deg);
}

#cta {
  color: #fff;
  align-items: center;
  justify-content: center;
  border: 0px transparent solid !important;
  margin-top: 1px;
}

.arrow {
  width: 8px;
  height: 8px;
  border: 0px transparent solid !important;
}

@keyframes bounceAlpha {
  0% {
    opacity: 1;
    transform: translateX(0px) scale(1);
  }
  25% {
    opacity: 0;
    transform: translateX(10px) scale(0.9);
  }
  26% {
    opacity: 0;
    transform: translateX(-10px) scale(0.9);
  }
  55% {
    opacity: 1;
    transform: translateX(0px) scale(1);
  }
}

@media (min-width: 577px) {
  .bounceAlpha {
    animation-name: bounceAlpha;
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  .arrow.primera.bounceAlpha {
    animation-name: bounceAlpha;
    animation-duration: 1.4s;
    animation-delay: 0.2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  .round .arrow {
    animation-name: bounceAlpha;
    animation-duration: 1.4s;
    animation-iteration-count: 3;
    animation-timing-function: linear;
  }
  .round .arrow.primera {
    animation-name: bounceAlpha;
    animation-duration: 1.4s;
    animation-delay: 0.2s;
    animation-iteration-count: 3;
    animation-timing-function: linear;
  }

  .round:hover .arrow {
    animation-name: bounceAlpha;
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  .round:hover .arrow.primera {
    animation-name: bounceAlpha;
    animation-duration: 1.4s;
    animation-delay: 0.2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
}
@media (max-width: 576px) {
  .arrow.primera {
    animation-name: bounceAlpha;
    animation-duration: 2s;
    animation-delay: 1.2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  .arrow {
    animation-name: bounceAlpha;
    animation-duration: 2s;
    animation-delay: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
}
</style>
